(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2896],{

/***/ 63512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25989);
/* harmony import */ var _Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62122);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17016);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96098);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  padding-right: 16px;
  padding-left: 16px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: ${_Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__/* .BREAK_POINTS.xl */ .d.xl}) {
    width: ${(props) => props.fluid ? "100%" : (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(props.maxWidth)};
  }
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .CommonStyles */ .F}
`;
const Container = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const _a = props, { children, fluid = false, maxWidth = 1232 } = _a, others = __objRest(_a, ["children", "fluid", "maxWidth"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    maxWidth,
    fluid,
    ref
  }, others), children);
});
Container.displayName = "Container";




/***/ }),

/***/ 93005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Divider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84019);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25989);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17016);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96098);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Divider = (_a) => {
  var _b = _a, {
    width = "100%",
    height = "1px",
    color = "black",
    dividerStyle = _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__/* .DividerStyleEnum.solid */ .fd.solid,
    align,
    gap,
    alignContent,
    spacingContent,
    children
  } = _b, rest = __objRest(_b, [
    "width",
    "height",
    "color",
    "dividerStyle",
    "align",
    "gap",
    "alignContent",
    "spacingContent",
    "children"
  ]);
  const renderSeparator = () => {
    if (!children) {
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperSeparator, {
        width,
        weight: height,
        dividerStyle,
        color,
        align
      });
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperSeparatorText, {
      width,
      weight: height,
      dividerStyle,
      color,
      align,
      alignContent,
      spacingContent
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, children));
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperDivider, __spreadProps(__spreadValues({}, rest), {
    gap
  }), renderSeparator());
};
const WrapperDivider = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(({ gap }) => [
  _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .CommonStyles */ .F,
  `
  --divider-gap: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_4__/* .pixelParse */ .oJ)(gap) || "12px"};
  display: flex;
  padding-top: var(--divider-gap);
  padding-bottom: var(--divider-gap);
`
]);
const transformAlign = (align) => {
  switch (align) {
    case _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__/* .Alignment.center */ .v2.center:
      return "margin: 0 auto;";
    case _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__/* .Alignment.right */ .v2.right:
      return `
        margin: 0 auto;
        margin-right: 0;
      `;
    default:
      return "";
  }
};
const transformAlignContent = (alignContent) => {
  const css = `{
    display: block;
    content: "";
    border-bottom: 0;
    flex-grow: 1;
    border-top: var(--divider-border-width) var(--divider-border-style) var(--divider-color);
  }`;
  switch (alignContent) {
    case _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__/* .Alignment.left */ .v2.left:
      return `
          &:after ${css}
        `;
    case _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__/* .Alignment.right */ .v2.right:
      return `
          &:before ${css}
        `;
    default:
      return `
          &:after, &:before ${css}
        `;
  }
};
const WrapperSeparator = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(({
  width,
  weight,
  dividerStyle,
  color,
  align,
  theme
}) => `
  --divider-border-style: ${dividerStyle};
  --divider-color: ${color ? theme.colors[color] || color : theme.colors.divider};
  --divider-border-width: ${weight || "1px"};
  display: flex;
  width: ${width ? width : "100%"};
  border-top: var(--divider-border-width) var(--divider-border-style) var(--divider-color);
  ${transformAlign(align)}
`);
const WrapperSeparatorText = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(({
  width,
  weight,
  dividerStyle,
  color = "black",
  align,
  alignContent,
  spacingContent,
  theme
}) => `
  --divider-border-style: ${dividerStyle};
  --divider-color: ${theme.colors[color] || color};
  --divider-border-width: ${weight || "1px"};
  --divider-content-spacing: ${spacingContent || "10px"};
  display: flex;
  align-items: center;
  width: ${width ? width : "100%"};
  ${transformAlign(align)}
  ${transformAlignContent(alignContent)}

  > span {
    margin: 0 var(--divider-content-spacing);
    margin-left: ${alignContent === "left" ? "0" : "var(--divider-content-spacing)"};
    margin-right: ${alignContent === "right" ? "0" : "var(--divider-content-spacing)"};
  }
`);
Divider.displayName = "Divider";




/***/ }),

/***/ 58519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JX": function() { return /* binding */ Col; },
/* harmony export */   "XE": function() { return /* binding */ floorPercentage; },
/* harmony export */   "e9": function() { return /* binding */ percentage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67085);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _RowContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43443);
/* harmony import */ var _constant_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62122);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25989);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72227);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17016);








var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function parseFlex(flex) {
  if (typeof flex === "number") {
    return `${flex} ${flex} auto`;
  }
  if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) {
    return `0 0 ${flex}`;
  }
  return flex;
}
const sizes = ["xs", "sm", "md", "lg", "xl", "xxl"];
const Col = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const { gutter, wrap } = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_RowContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
  const _a = props, {
    span,
    order,
    offset,
    push,
    pull,
    className,
    children,
    flex,
    style
  } = _a, others = __objRest(_a, [
    "span",
    "order",
    "offset",
    "push",
    "pull",
    "className",
    "children",
    "flex",
    "style"
  ]);
  const prefixCls = "teko-col";
  let sizeClassObj = {};
  sizes.forEach((size) => {
    let sizeProps = {};
    const propSize = props[size];
    if (typeof propSize === "number") {
      sizeProps.span = propSize;
    } else if (typeof propSize === "object") {
      sizeProps = propSize || {};
    }
    sizeClassObj = __spreadProps(__spreadValues({}, sizeClassObj), {
      [`${prefixCls}-${size}-${sizeProps.span}`]: sizeProps.span !== void 0,
      [`${prefixCls}-${size}-order-${sizeProps.order}`]: sizeProps.order || sizeProps.order === 0,
      [`${prefixCls}-${size}-offset-${sizeProps.offset}`]: sizeProps.offset || sizeProps.offset === 0,
      [`${prefixCls}-${size}-push-${sizeProps.push}`]: sizeProps.push || sizeProps.push === 0,
      [`${prefixCls}-${size}-pull-${sizeProps.pull}`]: sizeProps.pull || sizeProps.pull === 0
    });
  });
  const classes = classnames__WEBPACK_IMPORTED_MODULE_1___default()(prefixCls, {
    [`${prefixCls}-${span}`]: span !== void 0,
    [`${prefixCls}-order-${order}`]: order,
    [`${prefixCls}-offset-${offset}`]: offset,
    [`${prefixCls}-push-${push}`]: push,
    [`${prefixCls}-pull-${pull}`]: pull
  }, className, sizeClassObj);
  let mergedStyle = __spreadValues({}, style);
  if (gutter) {
    mergedStyle = __spreadValues(__spreadValues({}, gutter[0] && gutter[0] > 0 ? {
      paddingLeft: gutter[0] / 2,
      paddingRight: gutter[0] / 2
    } : {}), mergedStyle);
  }
  if (flex) {
    mergedStyle.flex = parseFlex(flex);
    if (flex === "auto" && wrap === false && !mergedStyle.minWidth) {
      mergedStyle.minWidth = 0;
    }
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCol, __spreadProps(__spreadValues({}, others), {
    style: mergedStyle,
    className: classes,
    ref
  }), children);
});
Col.displayName = "Col";
const floorPercentage = (percent) => {
  return Math.floor(percent * 100) / 100;
};
const percentage = (x, y) => {
  return floorPercentage(x / y * 100) + "%";
};
const loopGridColumn = (_class = "") => {
  let _css = `
    &.teko-col${_class}-0 {
      display: none;
    }
    &.teko-col-push-0 {
      left: auto;
    }
    &.teko-col-pull-0 {
      right: auto;
    }
    &.teko-col${_class}-push-0 {
      left: auto;
    }
    &.teko-col${_class}-pull-0 {
      right: auto;
    }
    &.teko-col${_class}-offset-0 {
      margin-left: 0;
    }
    &.teko-col${_class}-order-0 {
      order: 0;
    }
  `;
  for (let i = 1; i <= 24; i++) {
    _css += `
      &.teko-col${_class}-${i} {
        display: block;
        flex: 0 0 ${percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .GRID_COLUMNS */ .s)};
        max-width: ${_class === "-lg" ? "84px" : ["-xl", "-xxl"].includes(_class) ? "104px" : percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .GRID_COLUMNS */ .s)};
      }
      &.teko-col${_class}-push-${i} {
        left: ${percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .GRID_COLUMNS */ .s)};
      }
      &.teko-col${_class}-pull-${i} {
        right: ${percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .GRID_COLUMNS */ .s)};
      }
      &.teko-col${_class}-offset-${i} {
        margin-left: ${percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .GRID_COLUMNS */ .s)};
      }
      &.teko-col${_class}-order-${i} {
        order: ${i};
      }
    `;
  }
  return _css;
};
const makeGrid = _emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv`
  ${loopGridColumn()}
  ${loopGridColumn("-xs")}
  ${Object.keys(_constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .BREAK_POINTS */ .d).map((label) => label !== "xs" ? `
    @media (min-width: ${_constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .BREAK_POINTS */ .d[label]}) {
      ${loopGridColumn(`-${label}`)}
    }
  ` : "").join("")}
`;
const flexStyle = (flex) => {
  if (!flex)
    return;
  return `
    flex: ${parseFlex(flex)};
    ${typeof flex === "string" ? `max-width: ${flex} !important;` : ""}
  `;
};
const makeFlexStyles = (props) => {
  var _a;
  return _emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv`
    ${typeof props.xs === "object" && ((_a = props.xs) == null ? void 0 : _a.flex) !== void 0 ? flexStyle(props.xs.flex) : ""}
    ${Object.keys(_constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .BREAK_POINTS */ .d).map((label) => {
    var _a2, _b;
    return ((_a2 = props[label]) == null ? void 0 : _a2.flex) && label !== "xs" ? `
      @media (min-width: ${_constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .BREAK_POINTS */ .d[label]}) {
        ${flexStyle((_b = props[label]) == null ? void 0 : _b.flex)};
      }
    ` : "";
  }).join("")}
  `;
};
const StyledCol = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(`
  &.teko-col {
    position: relative;
    max-width: 100%;
    // Prevent columns from collapsing when empty
    min-height: 1px;
  }`, _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_6__/* .CommonStyles */ .F, makeGrid, makeFlexStyles);




/***/ }),

/***/ 49624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ Row; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/cache/classnames-npm-2.3.1-f2ae0a8d3c-14db8889d5.zip/node_modules/classnames/index.js
var classnames = __webpack_require__(67085);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Grid/RowContext.es.js
var RowContext_es = __webpack_require__(43443);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Grid/util.es.js
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const responsiveArray = [
  "xxl",
  "xl",
  "lg",
  "md",
  "sm",
  "xs"
];
const responsiveMap = {
  xs: "(max-width: 575px)",
  sm: "(min-width: 576px)",
  md: "(min-width: 768px)",
  lg: "(min-width: 1024px)",
  xl: "(min-width: 1440px)",
  xxl: "(min-width: 1600px)"
};
const subscribers = /* @__PURE__ */ new Map();
let subUid = -1;
let screens = {};
const responsiveObserve = {
  matchHandlers: {},
  dispatch(pointMap) {
    screens = pointMap;
    subscribers.forEach((func) => func(screens));
    return subscribers.size >= 1;
  },
  subscribe(func) {
    if (!subscribers.size)
      this.register();
    subUid += 1;
    subscribers.set(subUid, func);
    func(screens);
    return subUid;
  },
  unsubscribe(token) {
    subscribers.delete(token);
    if (!subscribers.size)
      this.unregister();
  },
  unregister() {
    Object.keys(responsiveMap).forEach((screen) => {
      const matchMediaQuery = responsiveMap[screen];
      const handler = this.matchHandlers[matchMediaQuery];
      handler == null ? void 0 : handler.mql.removeListener(handler == null ? void 0 : handler.listener);
    });
    subscribers.clear();
  },
  register() {
    Object.keys(responsiveMap).forEach((screen) => {
      const matchMediaQuery = responsiveMap[screen];
      const listener = ({ matches }) => {
        this.dispatch(__spreadProps(__spreadValues({}, screens), {
          [screen]: matches
        }));
      };
      const mql = window.matchMedia(matchMediaQuery);
      mql.addListener(listener);
      this.matchHandlers[matchMediaQuery] = {
        mql,
        listener
      };
      listener(mql);
    });
  }
};
var ResponsiveObserve = responsiveObserve;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Grid/constant.es.js
var constant_es = __webpack_require__(62122);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var index_es = __webpack_require__(25989);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-46f73e5ea2/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(17016);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Grid/Row.es.js








var Row_es_defProp = Object.defineProperty;
var Row_es_defProps = Object.defineProperties;
var Row_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Row_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Row_es_hasOwnProp = Object.prototype.hasOwnProperty;
var Row_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var Row_es_defNormalProp = (obj, key, value) => key in obj ? Row_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Row_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Row_es_hasOwnProp.call(b, prop))
      Row_es_defNormalProp(a, prop, b[prop]);
  if (Row_es_getOwnPropSymbols)
    for (var prop of Row_es_getOwnPropSymbols(b)) {
      if (Row_es_propIsEnum.call(b, prop))
        Row_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Row_es_spreadProps = (a, b) => Row_es_defProps(a, Row_es_getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Row_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Row_es_getOwnPropSymbols)
    for (var prop of Row_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Row_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Row = react.forwardRef((props, ref) => {
  const _a = props, {
    justify,
    align,
    className,
    style,
    children,
    gutter = 0,
    wrap
  } = _a, others = __objRest(_a, [
    "justify",
    "align",
    "className",
    "style",
    "children",
    "gutter",
    "wrap"
  ]);
  const [screens, setScreens] = react.useState({
    xs: true,
    sm: true,
    md: true,
    lg: true,
    xl: true,
    xxl: true
  });
  const gutterRef = react.useRef(gutter);
  react.useEffect(() => {
    const token = ResponsiveObserve.subscribe((screen) => {
      const currentGutter = gutterRef.current || 0;
      if (!Array.isArray(currentGutter) && typeof currentGutter === "object" || Array.isArray(currentGutter) && (typeof currentGutter[0] === "object" || typeof currentGutter[1] === "object")) {
        setScreens(screen);
      }
    });
    return () => ResponsiveObserve.unsubscribe(token);
  }, []);
  const getGutter = () => {
    const results = [0, 0];
    const normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
    normalizedGutter.forEach((g, index) => {
      if (typeof g === "object") {
        for (let i = 0; i < responsiveArray.length; i++) {
          const breakpoint = responsiveArray[i];
          if (screens[breakpoint] && g[breakpoint] !== void 0) {
            results[index] = g[breakpoint];
            break;
          }
        }
      } else {
        results[index] = g || 0;
      }
    });
    return results;
  };
  const prefixCls = "teko-row";
  const gutters = getGutter();
  const classes = classnames_default()(prefixCls, {
    [`${prefixCls}-no-wrap`]: wrap === false,
    [`${prefixCls}-${justify}`]: justify,
    [`${prefixCls}-${align}`]: align
  }, className);
  const rowStyle = Row_es_spreadValues(Row_es_spreadValues(Row_es_spreadValues({}, gutters[0] && gutters[0] > 0 ? {
    marginLeft: gutters[0] / -2,
    marginRight: gutters[0] / -2
  } : {}), gutters[1] && gutter[1] > 0 ? {
    rowGap: gutters[1]
  } : {}), style);
  return /* @__PURE__ */ react.createElement(RowContext_es/* default.Provider */.Z.Provider, {
    value: { gutter: gutters, wrap }
  }, /* @__PURE__ */ react.createElement(StyledRow, Row_es_spreadProps(Row_es_spreadValues({}, others), {
    className: classes,
    style: rowStyle,
    ref
  }), children));
});
Row.displayName = "Row";
const StyledRow = emotion_styled_browser_esm/* default.div */.Z.div`
  &.teko-row {
    display: flex;
    flex-flow: row wrap;
  }
  @media (min-width: ${constant_es/* BREAK_POINTS.lg */.d.lg}) {
    &.teko-row {
      justify-content: center;
    }
  }
  &.teko-row:before,
  &.teko-row:after {
    display: flex;
  }

  // No wrap of flex
  &.teko-row-no-wrap {
    flex-wrap: nowrap;
  }

  &.teko-row-start {
    justify-content: flex-start;
  }

  &.teko-row-center {
    justify-content: center;
  }

  &.teko-row-end {
    justify-content: flex-end;
  }

  &.teko-row-space-between {
    justify-content: space-between;
  }

  &.teko-row-space-around {
    justify-content: space-around;
  }

  &.teko-row-top {
    align-items: flex-start;
  }

  &.teko-row-middle {
    align-items: center;
  }
  &.teko-row-baseline {
    align-items: baseline;
  }

  &.teko-row-bottom {
    align-items: flex-end;
  }
  ${index_es/* CommonStyles */.F}
`;




/***/ }),

/***/ 43443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RowContext$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);


const RowContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var RowContext$1 = RowContext;




/***/ }),

/***/ 62122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ BREAK_POINTS; },
/* harmony export */   "s": function() { return /* binding */ GRID_COLUMNS; }
/* harmony export */ });
const BREAK_POINTS = {
  xs: "480px",
  sm: "576px",
  md: "768px",
  lg: "1024px",
  xl: "1440px",
  xxl: "1600px"
};
const GRID_COLUMNS = 12;




/***/ }),

/***/ 8081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17016);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96098);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const fallbackImage = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNjAiIGhlaWdodD0iMjYwIiB2aWV3Qm94PSIwIDAgMjYwIDI2MCI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGZpbGw9IiNGNkY2RjYiIGQ9Ik0wIDBoMjYwdjI2MEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMDQgMTA0aDU0djU0aC01NHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjQjRCNEI0IiBkPSJNMTUxLjI1IDEwNi4yNWE0LjUgNC41IDAgMCAxIDQuNSA0LjV2NDAuNWE0LjUgNC41IDAgMCAxLTQuNSA0LjVoLTQwLjVhNC41IDQuNSAwIDAgMS00LjUtNC41di00MC41YTQuNSA0LjUgMCAwIDEgNC41LTQuNWg0MC41em0tMTMuNSAxOGwtOSAxMy41TDEyMiAxMzFsLTYuNzUgMTEuMjVoMzEuNWwtOS0xOHptLTEyLjM3NS02Ljc1YTMuMzc1IDMuMzc1IDAgMSAwIDAgNi43NSAzLjM3NSAzLjM3NSAwIDAgMCAwLTYuNzV6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
const Image = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const _a = props, {
    src,
    height,
    objectFit,
    width,
    alt,
    onClick,
    borderRadius,
    thumbnail,
    hover,
    decoding = "async",
    className,
    lazy = true,
    pngSrc
  } = _a, others = __objRest(_a, [
    "src",
    "height",
    "objectFit",
    "width",
    "alt",
    "onClick",
    "borderRadius",
    "thumbnail",
    "hover",
    "decoding",
    "className",
    "lazy",
    "pngSrc"
  ]);
  const imgElement = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledImage, __spreadValues({
    ref,
    objectFit,
    src: src || fallbackImage,
    loading: lazy ? "lazy" : "eager",
    hover,
    height,
    decoding,
    alt
  }, others));
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, {
    height,
    width,
    onClick,
    borderRadius,
    thumbnail,
    className
  }, pngSrc ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("picture", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: src,
    type: "image/webp"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: pngSrc,
    type: "image/png"
  }), imgElement) : imgElement);
});
Image.displayName = "Image";
const Container = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(({ onClick, borderRadius, height, thumbnail, width }) => `
  position: relative;
  display: inline-block;
  overflow: hidden;
  ${onClick ? "cursor: pointer;" : ""}
  ${borderRadius ? `border-radius: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__/* .pixelParse */ .oJ)(borderRadius)};` : ""}
  ${height ? `height: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__/* .pixelParse */ .oJ)(height)};` : ""}
  ${width ? `width: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__/* .pixelParse */ .oJ)(width)};` : ""}
  ${thumbnail ? ` background-image: ${`url("${thumbnail}")`};
     background-size: cover;` : ""}
`);
const StyledImage = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].img */ .Z.img(({ hover, height, objectFit }) => `
  width: 100%;
  height: ${height ? `${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__/* .pixelParse */ .oJ)(height)}` : "auto"};
  ${objectFit ? `object-fit: ${objectFit}` : ""};
  transition: transform 0.3s;
  &:hover {
    ${hover === "zoom" ? "transform: scale(1.05)" : ""};
  };
`);




/***/ }),

/***/ 30221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ ChecklistOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const ChecklistOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.88334 3.75C7.88334 3.33579 8.21913 3 8.63334 3H15.4289C15.8431 3 16.1789 3.33579 16.1789 3.75V3.97071H17.3118C18.8306 3.97071 20.0618 5.20193 20.0618 6.72071V18.2533C20.0618 19.7721 18.8306 21.0033 17.3118 21.0033H6.75C5.23122 21.0033 4 19.7721 4 18.2533V6.72071C4 5.20193 5.23122 3.97071 6.75 3.97071H7.88334V3.75ZM16.1789 7.63315V5.47071H17.3118C18.0022 5.47071 18.5618 6.03036 18.5618 6.72071V18.2533C18.5618 18.9437 18.0022 19.5033 17.3118 19.5033H6.75C6.05964 19.5033 5.5 18.9437 5.5 18.2533V6.72071C5.5 6.03036 6.05964 5.47071 6.75 5.47071H7.88334V7.63315C7.88334 8.04736 8.21913 8.38315 8.63334 8.38315H10.3322C10.7464 8.38315 11.0822 8.04736 11.0822 7.63315C11.0822 7.42585 11.3581 7.00247 12.0311 7.00247C12.7041 7.00247 12.98 7.42585 12.98 7.63315C12.98 8.04736 13.3158 8.38315 13.73 8.38315H15.4289C15.8431 8.38315 16.1789 8.04736 16.1789 7.63315ZM9.38334 4.5V6.88315H9.73243C10.0999 6.01694 11.0835 5.50247 12.0311 5.50247C12.9787 5.50247 13.9623 6.01694 14.3298 6.88315H14.6789V4.5H9.38334ZM15.6523 12.0465C15.9452 11.7536 15.9452 11.2788 15.6523 10.9859C15.3594 10.693 14.8845 10.693 14.5916 10.9859L11.3282 14.2493L10.1341 13.0552C9.84125 12.7623 9.36638 12.7623 9.07348 13.0552C8.78059 13.3481 8.78059 13.8229 9.07348 14.1158L10.7979 15.8403C10.9386 15.9809 11.1293 16.0599 11.3282 16.0599C11.5271 16.0599 11.7179 15.9809 11.8586 15.8403L15.6523 12.0465Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 93692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ PromoOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const PromoOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.19499 3C5.99608 3 5.80532 3.07902 5.66466 3.21967L3.21967 5.66466C3.07902 5.80532 3 5.99608 3 6.19499V11.085C3 11.2839 3.07902 11.4747 3.21967 11.6153L12.3884 20.784C12.6813 21.0769 13.1562 21.0769 13.4491 20.784L17.1166 17.1166L20.784 13.4491C21.0769 13.1562 21.0769 12.6813 20.784 12.3884L11.6153 3.21967C11.4747 3.07902 11.2839 3 11.085 3H6.19499ZM4.5 6.50565L6.50565 4.5H10.7743L19.1931 12.9187L16.0559 16.0559L12.9187 19.1931L4.5 10.7743V6.50565ZM7.86186 9.2514C7.86186 8.65286 8.34707 8.16765 8.94561 8.16765C9.54415 8.16765 10.0294 8.65286 10.0294 9.2514C10.0294 9.84994 9.54415 10.3351 8.94561 10.3351C8.34707 10.3351 7.86186 9.84994 7.86186 9.2514ZM8.94561 6.66765C7.51865 6.66765 6.36186 7.82444 6.36186 9.2514C6.36186 10.6784 7.51865 11.8351 8.94561 11.8351C10.3726 11.8351 11.5294 10.6784 11.5294 9.2514C11.5294 7.82444 10.3726 6.66765 8.94561 6.66765ZM11.3097 12.9996C11.0168 12.7067 10.5419 12.7067 10.249 12.9996C9.95613 13.2925 9.95613 13.7674 10.249 14.0603L12.3884 16.1996C12.6813 16.4925 13.1562 16.4925 13.449 16.1996C13.7419 15.9067 13.7419 15.4319 13.449 15.139L11.3097 12.9996ZM12.694 10.5545C12.9869 10.2616 13.4618 10.2616 13.7547 10.5545L15.8941 12.6939C16.187 12.9868 16.187 13.4616 15.8941 13.7545C15.6012 14.0474 15.1263 14.0474 14.8334 13.7545L12.694 11.6151C12.4011 11.3223 12.4011 10.8474 12.694 10.5545Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 14214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ ShoppingCartOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const ShoppingCartOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 3.75C3 3.33579 3.33579 3 3.75 3H6.00033C6.41455 3 6.75033 3.33579 6.75033 3.75V6.00035H18.7522C18.9832 6.00035 19.2012 6.10676 19.3434 6.28879C19.4855 6.47083 19.5358 6.7082 19.4798 6.93225L17.9796 12.9331C17.8961 13.267 17.5961 13.5012 17.252 13.5012H6.75033V14.2516C6.75033 14.4505 6.82937 14.6413 6.97007 14.782C7.11076 14.9227 7.30158 15.0018 7.50055 15.0018H19.5023C19.9165 15.0018 20.2523 15.3376 20.2523 15.7518C20.2523 16.166 19.9165 16.5018 19.5023 16.5018H7.50055C6.90376 16.5018 6.33141 16.2647 5.90941 15.8427C5.48741 15.4207 5.25033 14.8483 5.25033 14.2516V12.7544C5.25033 12.7534 5.25033 12.7523 5.25033 12.7512C5.25033 12.7502 5.25033 12.7491 5.25033 12.748V6.75355C5.25033 6.75249 5.25033 6.75142 5.25033 6.75035C5.25033 6.74929 5.25033 6.74822 5.25033 6.74715V4.5H3.75C3.33579 4.5 3 4.16421 3 3.75ZM6.75033 7.50035V12.0012H16.6664L17.7916 7.50035H6.75033ZM6.0006 19.5024C6.0006 18.6739 6.67222 18.0023 7.50071 18.0023C8.3292 18.0023 9.00082 18.6739 9.00082 19.5024C9.00082 20.3309 8.3292 21.0025 7.50071 21.0025C6.67222 21.0025 6.0006 20.3309 6.0006 19.5024ZM18.0021 18.0023C17.1736 18.0023 16.502 18.6739 16.502 19.5024C16.502 20.3309 17.1736 21.0025 18.0021 21.0025C18.8306 21.0025 19.5022 20.3309 19.5022 19.5024C19.5022 18.6739 18.8306 18.0023 18.0021 18.0023Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 77405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ CartNumberTracking; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);


const CartNumberTracking = ({
  totalItems
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "shoppingCartProductNumber",
    style: { display: "none" }
  }, totalItems);
};




/***/ }),

/***/ 18546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CustomLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38815);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55271);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Anchor = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.a */ .z.a`
  color: unset;
  text-decoration: unset;
`;
const CustomLink = (_a) => {
  var _b = _a, {
    targetPath,
    children,
    targetType = "_self",
    passHref = false
  } = _b, props = __objRest(_b, [
    "targetPath",
    "children",
    "targetType",
    "passHref"
  ]);
  if (!targetPath)
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  const a11yProps = {};
  if (typeof children !== "string") {
    a11yProps["aria-label"] = "Image";
  }
  if (targetPath.startsWith("http") || targetPath.startsWith("/"))
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, __spreadValues(__spreadValues({
      target: targetType,
      href: targetPath
    }, a11yProps), props), children);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
    href: passHref ? targetPath : `/search?${targetPath}`,
    prefetch: false,
    legacyBehavior: true
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, __spreadValues(__spreadValues({
    target: targetType,
    href: passHref ? targetPath : `/search?${targetPath}`
  }, a11yProps), props), children));
};




/***/ }),

/***/ 46899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ Messenger; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(55271);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-bb101883bc/1/packages/ecommerce/dist/assets/images/live-chat-full.es.js
var messengerFull = "https://shopfront-cdn.tekoapis.com/static/3ad4c9a97ab98ff3.png";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-bb101883bc/1/packages/ecommerce/dist/assets/images/live-chat.es.js
var messenger = "https://shopfront-cdn.tekoapis.com/static/a8e347d31db4d701.png";



// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(28247);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-bb101883bc/1/packages/ecommerce/dist/Common/Messenger/Messenger.es.js






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const Wrapper = styled_es/* styled.a */.z.a`
  z-index: 1030;
  position: fixed;
  right: 2.5rem;
  bottom: 5.6rem;
  cursor: pointer;
  @media (min-width: 1440px) {
    .fb-chat-full {
      display: block;
    }
    .fb-chat {
      display: none;
    }
  }
  @media (max-width: 1440px) {
    .fb-chat-full {
      display: none;
    }
    .fb-chat {
      display: block;
    }
  }
  @media print {
    display: none;
  }
`;
const Messenger = ({
  url
}) => {
  return /* @__PURE__ */ react.createElement(Wrapper, __spreadValues({
    href: url,
    target: "_blank",
    rel: "noreferrer"
  }, (0,helper_es/* getTrackingData */.O)({
    isTrackContent: true,
    regionName: "quickAction",
    contentName: "fbMessengerIcon"
  })), /* @__PURE__ */ react.createElement("img", {
    className: "fb-chat-full",
    src: messengerFull,
    alt: "fb-chat"
  }), /* @__PURE__ */ react.createElement("img", {
    className: "fb-chat",
    src: messenger,
    alt: "fb-chat"
  }));
};




/***/ }),

/***/ 79217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-bb101883bc/1/packages/ecommerce/dist/i18n.es.js
var i18n_es = __webpack_require__(61988);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(55271);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/Container/Container.es.js
var Container_es = __webpack_require__(58277);
// EXTERNAL MODULE: ../../.yarn/__virtual__/reflexbox-virtual-95900ce272/0/cache/reflexbox-npm-4.0.6-201af1058c-b532551c8b.zip/node_modules/reflexbox/dist/index.js
var dist = __webpack_require__(98522);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/Button/Button.es.js
var Button_es = __webpack_require__(50983);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-bb101883bc/1/packages/ecommerce/dist/Layout/Footer/components/FooterBlock/FooterBlock.es.js



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ColumnTitle = styled_es/* styled.div */.z.div`
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
`;
const StyledButton = (0,styled_es/* styled */.z)(Button_es/* Button */.z)((props) => `
  font-size: 12px;
  color: #333;
  padding-left: 0px;
  text-align: left;
  text-decoration: none;
  padding-bottom: 0px;
  max-width: ${!props.block ? "72px" : "initial"};
  justify-content: flex-start;
`);
const ContactInnerLine = styled_es/* styled.div */.z.div`
  font-size: 12px;
  width: 100%;
  a {
    text-decoration: none;
  }
  span {
    line-height: 1.5rem;
  }
  padding-top: 0.365rem;
  padding-right: 0.75rem;
`;
const StyledImg = styled_es/* styled.img */.z.img((props) => `
  ${props.isLogo ? "max-width: 180px;" : ""}
  width: 100%;
`);
const FooterBlock = ({
  title,
  links = [],
  emails = [],
  phones = [],
  flexDir = "row",
  image,
  isLogoImage,
  btnBlock = true
}) => {
  return /* @__PURE__ */ react.createElement(react.Fragment, null, title && /* @__PURE__ */ react.createElement(ColumnTitle, {
    key: title
  }, title), emails.map((email, index) => {
    return /* @__PURE__ */ react.createElement(ContactInnerLine, {
      key: `email-${index}`,
      dangerouslySetInnerHTML: {
        __html: `${email.children} <a href='mailto:${email.address}'>${email.address}</a>`
      }
    });
  }), phones.map((phone, index) => {
    return /* @__PURE__ */ react.createElement(ContactInnerLine, {
      key: `phone-${index}`,
      dangerouslySetInnerHTML: {
        __html: `${phone.children} <a href='tel:${phone.number.replace(/\./g, "")}'}>${phone.number}</a>`
      }
    });
  }), links.map((link, index) => {
    return /* @__PURE__ */ react.createElement(StyledButton, __spreadValues({
      tag: "a",
      block: btnBlock,
      link: true,
      key: `link-${index}`,
      flexDirection: flexDir
    }, link));
  }), image && /* @__PURE__ */ react.createElement(StyledImg, {
    isLogo: !!isLogoImage,
    src: image,
    alt: ""
  }));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-bb101883bc/1/packages/ecommerce/dist/Layout/Footer/Footer.es.js






const FooterWrapper = styled_es/* styled.div */.z.div(({ theme }) => `
  @media print {
    display: none;
  }
  border-top: solid 3px ${theme.brand.primary};
  position: relative;
`);
const Wrapper = styled_es/* styled.nav */.z.nav(({ theme }) => `
  background-color: ${theme.colors.white};
  padding: 1rem 0;
`);
const StyledContainer = (0,styled_es/* styled */.z)(Container_es/* Container */.W)`
  display: flex;
  margin-bottom: 10px;
`;
const ColumnInnerLine = styled_es/* styled.div */.z.div`
  font-size: 12px;
  width: 100%;
  padding-right: 8px;
  a {
    color: #333;
    text-decoration: none;
    display: flex;
    align-items: center;
  }
  span {
    line-height: 1.5rem;
  }
`;
const StyledWrapper = (0,styled_es/* styled */.z)(Wrapper)(({ customBottomColor, theme }) => `
  background-color: ${customBottomColor && theme.colors[customBottomColor] || "#e9edf2"};
  margin-top: -10px;
  padding-top: 30px;
  padding-bottom: 25px;
`);
const CompanyName = styled_es/* styled.div */.z.div`
  font-size: 14px;
  text-transform: uppercase;
  font-weight: bold;
  margin-bottom: 15px;
`;
const BranchName = styled_es/* styled.span */.z.span`
  font-size: 12px;
  font-weight: bold;
`;
const Footer_es_StyledImg = styled_es/* styled.img */.z.img`
  width: 100%;
  max-width: 160px;
`;
const StyledLink = styled_es/* styled.a */.z.a`
  display: block;
  &:not(:first-child) {
    margin-top: 0.5rem;
  }
`;
const StyledDMCA = styled_es/* styled.div */.z.div`
  margin-top: 0.5rem;
  img {
    width: 100%;
    max-width: 100px;
  }
`;
const Description = styled_es/* styled.p */.z.p`
  font-size: 0.75rem;
  text-align: center;
  margin: 0;
`;
const getResponsiveWidth = (col) => {
  switch (col) {
    case 2:
      return [1 / 2, 1 / 2, 1 / 2, 1 / 2];
    case 3:
      return [1 / 2, 1 / 2, 1 / 2, 1 / 3];
    case 4:
      return [1 / 2, 1 / 2, 1 / 2, 1 / 4];
    default:
      return [1 / 2, 1 / 3, 1 / 3, 1 / 5];
  }
};
const Footer = ({
  footer,
  customBottomColor,
  baseUrl
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
  return /* @__PURE__ */ react.createElement(FooterWrapper, null, (footer.bankList || footer.supportAndPolicy || footer.paymentMethods) && /* @__PURE__ */ react.createElement(Wrapper, null, footer.supportAndPolicy && /* @__PURE__ */ react.createElement(StyledContainer, null, /* @__PURE__ */ react.createElement(dist/* Flex */.kC, {
    flexWrap: "wrap",
    justifyContent: "space-between",
    width: "100%"
  }, footer.supportAndPolicy.map((column, index) => {
    return /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
      width: getResponsiveWidth(footer.supportAndPolicy.length),
      key: index
    }, /* @__PURE__ */ react.createElement(FooterBlock, {
      title: column.title,
      links: column.links,
      emails: column.emails,
      phones: column.phones,
      image: column.image,
      isLogoImage: true
    }));
  }))), /* @__PURE__ */ react.createElement(StyledContainer, null, /* @__PURE__ */ react.createElement(dist/* Flex */.kC, {
    flexWrap: "wrap"
  }, footer.paymentMethods && /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, 1, "40%"]
  }, /* @__PURE__ */ react.createElement(FooterBlock, {
    title: footer.paymentMethods.title,
    links: footer.paymentMethods.links,
    flexDir: "column",
    btnBlock: false
  })), footer.bankList && /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, 1, "60%"]
  }, /* @__PURE__ */ react.createElement(FooterBlock, {
    title: (0,i18n_es.t)("Danh s\xE1ch c\xE1c ng\xE2n h\xE0ng thanh to\xE1n online"),
    image: footer.bankList.imgSrc
  }))))), footer.bottom && /* @__PURE__ */ react.createElement(StyledWrapper, {
    customBottomColor
  }, /* @__PURE__ */ react.createElement(StyledContainer, null, /* @__PURE__ */ react.createElement(dist/* Flex */.kC, {
    flexWrap: "wrap",
    width: "100%"
  }, /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, "50%", "35%", "40%"]
  }, ((_a = footer.bottom) == null ? void 0 : _a.company) && /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(CompanyName, null, (_b = footer.bottom) == null ? void 0 : _b.company.name), /* @__PURE__ */ react.createElement(ColumnInnerLine, {
    dangerouslySetInnerHTML: {
      __html: (_c = footer.bottom) == null ? void 0 : _c.company.detail
    }
  }))), /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, "50%", "35%", "40%"]
  }, footer.bottom.address && footer.bottom.address.map((addressDetail) => {
    return /* @__PURE__ */ react.createElement("div", {
      key: addressDetail.branchName
    }, /* @__PURE__ */ react.createElement(BranchName, null, addressDetail.branchName), ":", /* @__PURE__ */ react.createElement(ColumnInnerLine, null, addressDetail.branchAddress));
  }), footer.bottom.phone && footer.bottom.email && /* @__PURE__ */ react.createElement(ColumnInnerLine, null, `${(0,i18n_es.t)("S\u1ED1 \u0111i\u1EC7n tho\u1EA1i")}: ${footer.bottom.phone} - Email: ${footer.bottom.email} `)), /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, "100%", "30%", "20%"]
  }, !!((_e = (_d = footer == null ? void 0 : footer.bottom) == null ? void 0 : _d.registeredLogo) == null ? void 0 : _e.logo) && /* @__PURE__ */ react.createElement(StyledLink, {
    href: (_f = footer.bottom.registeredLogo) == null ? void 0 : _f.link,
    rel: "noreferrer noopener",
    target: "_blank"
  }, /* @__PURE__ */ react.createElement(Footer_es_StyledImg, {
    src: footer.bottom.registeredLogo.logo,
    alt: "registered logo"
  })), !!((_h = (_g = footer == null ? void 0 : footer.bottom) == null ? void 0 : _g.verifiedLogo) == null ? void 0 : _h.logo) && /* @__PURE__ */ react.createElement(StyledLink, {
    href: (_i = footer.bottom.verifiedLogo) == null ? void 0 : _i.link,
    rel: "noreferrer noopener",
    target: "_blank"
  }, /* @__PURE__ */ react.createElement(Footer_es_StyledImg, {
    src: footer.bottom.verifiedLogo.logo,
    alt: "verified logo"
  })), ((_j = footer == null ? void 0 : footer.bottom) == null ? void 0 : _j.dmcaBadgeLink) && ((_k = footer == null ? void 0 : footer.bottom) == null ? void 0 : _k.dmcaId) && /* @__PURE__ */ react.createElement(StyledDMCA, null, /* @__PURE__ */ react.createElement("a", {
    href: `//www.dmca.com/Protection/Status.aspx?ID=${(_l = footer == null ? void 0 : footer.bottom) == null ? void 0 : _l.dmcaId}&refurl=${baseUrl}`,
    title: "DMCA.com Protection Status",
    className: "dmca-badge"
  }, /* @__PURE__ */ react.createElement("img", {
    src: `${(_m = footer == null ? void 0 : footer.bottom) == null ? void 0 : _m.dmcaBadgeLink}?ID=${(_n = footer == null ? void 0 : footer.bottom) == null ? void 0 : _n.dmcaId}`,
    alt: "DMCA.com Protection Status"
  })))), /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1]
  }, ((_o = footer == null ? void 0 : footer.bottom) == null ? void 0 : _o.description) && /* @__PURE__ */ react.createElement(Description, {
    dangerouslySetInnerHTML: {
      __html: footer.bottom.description
    }
  }))))));
};




/***/ }),

/***/ 68481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ NAMESPACE; },
  "K": function() { return /* binding */ lang; },
  "t": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(96556);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/lang/vi.es.js
var viLang = {
	"src.components.ProductCard.ProductCard.0": "Sản phẩm này là đồ uống có cồn, quý khách cần xác nhận mình trên 18 tuổi để mua sản phẩm!"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/lang/en.es.js
var enLang = {
	"Kết thúc sau": "End in",
	"ngày": "day",
	"Còn {{DurationDays}} ngày": "{{DurationDays}} days left",
	"Giảm trực tiếp": "Discount",
	"Tặng": "Receive",
	"GIẢM": "Decrease",
	"Không tìm thấy sản phẩm nào": "No product found",
	"Cảnh báo": "Warning",
	"src.components.ProductCard.ProductCard.0": "This is alcohol product, please confirm you are 18 years old to purchase!",
	"Tôi trên 18 tuổi": "I am over 18",
	"Tôi dưới 18 tuổi": "I am under 18",
	"Xác nhận": "Confirm",
	"TIẾT KIỆM": "Save",
	"Xem thêm": "Expand",
	"Bộ lọc đã dùng": "Used filter",
	"Xóa bộ lọc": "Clear filter",
	"Hàng trưng bày": "Sample",
	"Hàng đặt trước": "Pre-order",
	"Ngừng kinh doanh": "Stop selling",
	"Hàng quà tặng": "Gift",
	"Còn lại {{var0}}": "{{var0}} left",
	"Đã bán {{FlSaleUsedCount}}": "{{FlSaleUsedCount}} sold",
	"Hàng sắp về": "Coming soon",
	"Liên hệ": "Contact",
	"Còn {{stockQuantity}} sản phẩm": "{{stockQuantity}} left",
	"Xem tất cả": "View all",
	"Thương hiệu nổi bật": "Featured brands",
	"Danh mục sản phẩm": "Categories",
	"Sản phẩm dành cho bạn": "Products for you",
	"Chọn ngày nhận hàng": "Select delivery date",
	"Chọn khung giờ": "Select delivery time"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/i18n.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "teko-ecommerce";
const t = (keys, options) => {
  const text = i18next/* default.t */.Z.t(keys, __spreadProps(__spreadValues({}, options), { ns: NAMESPACE }));
  return text || keys;
};
const lang = {
  vi: viLang,
  en: enLang
};




/***/ }),

/***/ 29556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Dropdown; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55271);
/* harmony import */ var _DropdownContext_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19098);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const DropdownWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  width: 100%;
`;
const Dropdown = (_a) => {
  var _b = _a, {
    children,
    isOpen,
    toggle,
    toggleType = "click",
    className,
    onHide
  } = _b, props = __objRest(_b, [
    "children",
    "isOpen",
    "toggle",
    "toggleType",
    "className",
    "onHide"
  ]);
  const wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!isOpen) {
      return;
    }
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        toggle();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef, isOpen]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_DropdownContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .DropdownProvider */ .K, {
    value: { isOpen, toggle, toggleType }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DropdownWrapper, __spreadValues({
    onMouseEnter: toggleType === "hover" ? toggle : null,
    onMouseLeave: toggleType === "hover" ? onHide : null,
    className,
    ref: wrapperRef
  }, props), children));
};




/***/ }),

/***/ 19098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ DropdownContext; },
/* harmony export */   "K": function() { return /* binding */ DropdownProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const initialState = {
  referenceElement: null,
  toggle: () => {
  },
  isOpen: false,
  toggleType: ""
};
const DropdownContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(initialState);
const DropdownProvider = ({ children, value }) => {
  const [state, dispatch] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)((state2 = initialState, action) => {
    switch (action.type) {
      case "SET_REFERENCE":
        return __spreadProps(__spreadValues({}, state2), {
          referenceElement: action.payload
        });
      default:
        return state2;
    }
  }, initialState);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DropdownContext.Provider, {
    value: { state: __spreadValues(__spreadValues({}, state), value), dispatch }
  }, children);
};




/***/ }),

/***/ 32762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ DropdownMenu; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _DropdownContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19098);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55271);
/* harmony import */ var _Popper_Popper_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46023);





const StyledDiv = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ show, origin }) => `
    background-color: transparent;
    // transition: transform 0.2s, opacity 0.2s;
    // transform: scale(${show ? 1 : 0});
    // transform-origin: ${origin};
    opacity: ${show ? 1 : 0};
  `);
const StyledPopper = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_Popper_Popper_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Popper */ .r)(({ show }) => `
    visibility: ${show ? "visible" : "hidden"};
    z-index: 999;
  `);
const DropdownMenu = ({
  children,
  popperConfig,
  placement = "bottom-start",
  origin = "center top",
  className
}) => {
  const {
    state: { isOpen, referenceElement }
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_DropdownContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .DropdownContext */ .D);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPopper, {
    className,
    referenceElement,
    popperConfig,
    placement,
    show: isOpen
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledDiv, {
    show: isOpen,
    origin
  }, children));
};




/***/ }),

/***/ 37753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DropdownToggle; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55271);
/* harmony import */ var _DropdownContext_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19098);




const StyledDiv = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  width: 100%;
  &:focus {
    outline: none;
  }
`;
const DropdownToggle = ({
  children,
  className
}) => {
  const [anchor, setAnchor] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  const {
    state: { toggle, toggleType },
    dispatch
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_DropdownContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .DropdownContext */ .D);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    dispatch({ type: "SET_REFERENCE", payload: anchor });
  }, [anchor]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledDiv, {
    className,
    ref: setAnchor,
    onClick: toggleType === "click" ? toggle : null,
    onKeyUp: toggleType === "click" ? toggle : null,
    tabIndex: 0
  }, children);
};




/***/ }),

/***/ 46023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Popper; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var react_popper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71316);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55271);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Container = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  [data-popper-reference-hidden] {
    visibility: hidden;
    pointer-events: none;
  }
`;
const Popper = (_a) => {
  var {
    children,
    referenceElement,
    className,
    placement,
    popperConfig: _b = {}
  } = _a, _c = _b, { modifiers = [] } = _c, rest = __objRest(_c, ["modifiers"]);
  const [popperElement, setPopperElement] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  const [arrowElement, setArrowElement] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  const { styles, attributes, update } = (0,react_popper__WEBPACK_IMPORTED_MODULE_2__/* .usePopper */ .D)(referenceElement, popperElement, __spreadValues({
    placement,
    modifiers: [
      {
        name: "arrow",
        options: { element: arrowElement }
      },
      {
        name: "flip",
        enabled: true
      },
      { name: "hide" },
      ...modifiers
    ]
  }, rest));
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (update) {
      update();
    }
  }, [className]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, __spreadProps(__spreadValues({
    ref: setPopperElement,
    style: styles.popper
  }, attributes.popper), {
    className
  }), children, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: setArrowElement,
    style: styles.arrow
  }));
};




/***/ }),

/***/ 35336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ ScrollTopArrow; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55271);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63438);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28247);
/* harmony import */ var _atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46610);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ScrollToTopBtn = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div((props) => `
  border-radius: 50%;
  background-color: ${props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3rem;
  height: 3rem;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.08);
`);
const ScrollToTopWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(({ showScroll, position }) => `
  display: ${showScroll ? "block" : "none"};
  z-index: 1030;
  position: fixed;
  ${position.bottom ? `bottom: ${position.bottom}rem;` : ""}
  ${position.top ? `top: ${position.top}rem;` : ""}
  ${position.left ? `left: ${position.left}rem;` : ""}
  ${position.right ? `right: ${position.right}rem;` : ""}
  cursor: pointer;
  animation: fadeIn 0.3s;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 0.5;
    }
  }
`);
const ScrollTopArrow = ({
  className,
  color = "#ffffff",
  backgroundColor = " #333333",
  position = { bottom: 10, right: 3 },
  scrollTopRouters
}) => {
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  const [showScroll, setShowScroll] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const scrollTopTop = () => {
    if (typeof window !== "undefined")
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
  };
  const checkScrollTop = () => {
    if (typeof window !== "undefined") {
      if (!showScroll && window.pageYOffset > 700) {
        setShowScroll(true);
      } else if (showScroll && window.pageYOffset <= 700) {
        setShowScroll(false);
      }
    }
  };
  if (typeof window !== "undefined")
    window.addEventListener("scroll", checkScrollTop);
  let hasRouter = false;
  (scrollTopRouters == null ? void 0 : scrollTopRouters.length) > 0 && scrollTopRouters.forEach((route) => {
    if (router.pathname.startsWith(route)) {
      hasRouter = true;
      return;
    }
  });
  if ((scrollTopRouters == null ? void 0 : scrollTopRouters.length) > 0 && !hasRouter)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ScrollToTopWrapper, __spreadValues({
    showScroll,
    position
  }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .getTrackingData */ .O)({
    isTrackContent: true,
    regionName: "btnScrollTop",
    contentName: "btnScrollTop"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ScrollToTopBtn, {
    className,
    onClick: () => scrollTopTop(),
    backgroundColor
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__/* .SvgIcon */ .l, {
    name: "up",
    size: 24,
    color
  })));
};




/***/ }),

/***/ 4611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "w": function() { return /* binding */ useIdentifiedPage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);

const useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : 0;
const useIdentifiedPage = (className)=>{
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const node = document.createElement("div");
        node.className = className;
        node.style.display = "none";
        document.body.prepend(node);
        return ()=>node.remove();
    }, []);
};


/***/ }),

/***/ 54846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useRegionPicker; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25154);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55140);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65569);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71323);








const useRegionPicker = ()=>{
    var ref;
    const { isMobile , originalTerminal  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    const terminals = Array.isArray(originalTerminal) ? originalTerminal : [];
    const selectedTerminal = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getUserSelectedInfo */ .Sk)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.TERMINAL */ .Tp.TERMINAL, isMobile);
    const selectedLocation = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getUserSelectedInfo */ .Sk)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.LOCATION */ .Tp.LOCATION, isMobile);
    const selectedTerminalId = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getUserSelectedInfo */ .Sk)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.TERMINAL_ID */ .Tp.TERMINAL_ID, isMobile);
    const enableLocationFeature = terminals.every((item)=>!!item.locationCode);
    const confirmedOptionIndex = terminals.findIndex((item)=>{
        if (enableLocationFeature) {
            return item.code === selectedTerminal && item.locationCode === selectedLocation;
        }
        return item.code === selectedTerminal;
    });
    const { 0: showRegionPopup , 1: setShowRegionPopup  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: selected , 1: setSelected  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(confirmedOptionIndex === -1 ? 0 : confirmedOptionIndex);
    const selectTerminal = (terminal)=>{
        var ref;
        (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .setUserSelectedInfo */ .MA)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.TERMINAL */ .Tp.TERMINAL, terminal.code, isMobile);
        (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .setUserSelectedInfo */ .MA)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.TERMINAL_ID */ .Tp.TERMINAL_ID, terminal === null || terminal === void 0 ? void 0 : (ref = terminal.id) === null || ref === void 0 ? void 0 : ref.toString(), isMobile);
        enableLocationFeature && (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .setUserSelectedInfo */ .MA)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.LOCATION */ .Tp.LOCATION, terminal.locationCode, isMobile);
    };
    const onSubmitNewLocation = ()=>{
        selectTerminal(terminals[selected]);
         true && window.location.reload();
    };
    const activeLocation = confirmedOptionIndex || confirmedOptionIndex === 0 ? terminals[confirmedOptionIndex] : null;
    const textMsg = "Vui l\xf2ng chọn khu vực để ch\xfang t\xf4i sắp xếp giao h\xe0ng cho bạn nhanh nhất.";
    // temporarily rely on the location object present terminal
    const useDropdownPicker = !!((ref = terminals[0]) === null || ref === void 0 ? void 0 : ref.location);
    const onClosePopup = ()=>{
        if (activeLocation) {
            setShowRegionPopup(false);
            setSelected(confirmedOptionIndex === -1 ? 0 : confirmedOptionIndex);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // terminalId is a new key added later
        // we want to deprecate terminalCode
        // so for site without terminalId, prompt region picker
        const isTerminalSelected = !!selectedTerminal && !!selectedTerminalId;
        // if terminals include just one element --> auto set this element
        if (terminals.length === 1 && !isTerminalSelected) {
            selectTerminal(terminals[0]);
        } else {
            // add check !activeLocation in case the list of locations changes
            // on server-side, and user
            setShowRegionPopup(enableLocationFeature ? !isTerminalSelected || !selectedLocation || !activeLocation : !isTerminalSelected);
        }
    }, [
        selectedTerminal,
        selectedLocation,
        selectedTerminalId
    ]);
    return {
        showPopup: showRegionPopup,
        setShowPopup: setShowRegionPopup,
        onOpenPopup: ()=>setShowRegionPopup(true),
        onClosePopup,
        selected,
        setSelected,
        terminals,
        locationOptions: terminals.map((el, index)=>({
                text: el.label,
                value: index
            })),
        onSubmitNewLocation,
        activeLocation,
        useDropdownPicker,
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
            level: 1,
            children: textMsg
        })
    };
};


/***/ }),

/***/ 29234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useTermsAndPolicies; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55140);
/* harmony import */ var services_cosmic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48403);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70182);




const useTermsAndPolicies = ()=>{
    const { 0: termsAndPolicies , 1: setTermsAndPolicies  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
    const { partner , tenant  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_1__/* .useTenantConfig */ .Wx)();
    const cosmicBucketName = (0,helpers__WEBPACK_IMPORTED_MODULE_2__/* .isVnpay */ .EU)(partner) ? "vnpay" : tenant;
    const getPost = async (slug)=>{
        return await services_cosmic__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getPost */ .Z.getPost(slug, cosmicBucketName);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!cosmicBucketName) {
            return;
        }
        services_cosmic__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getSlugs */ .Z.getSlugs(cosmicBucketName).then((slugs)=>{
            setTermsAndPolicies(slugs);
        });
    }, [
        cosmicBucketName
    ]);
    return {
        getPost,
        termsAndPolicies
    };
};


/***/ }),

/***/ 48403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _clients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61640);

const accessKey = {
    vnshop: "ulISdNDAN9MMpNCfXhTOSNQdh9tF0xXOL65PdIz6cfw7J319cG",
    karavan: "N0VNt8uGaO0QxlXLEKGcIsKiqGYeuejw0AK4YeYjla0A1qLlVN",
    "masan-dealer": "LXHbZ3HipKU8LryekO5PIubqhZiJNwrw7eiNkxnGZxd6z1jJkY",
    umbala: "5KihnfendgNLL7k4zZVjBiwE27nYcKcuz6kwxpTXHo8AxYPrRf",
    vinmart: "6OC98OJNAOT9qzq1g6t6UnP72zqOt5tXMurVJ2qELvKovQX70M",
    cpvn: "vXraTMSIWKfTpYZX1YV9LO8XX0Q5pQXLRr9kgGlri635EUlisf",
    takashimaya: "JOUu6Kf1RuuSHfsegx2fkzd13NJSCcrOvxXB6gI6QpYIna4LCv",
    vnpay: "ZvfT9WRG2KZ2dEF8tCRaKgbJZRdqhG0XckUHzkBhHy8XaGHK7K",
    ipp: "YO71gfq1uvrjBaScttrzp4CV6rs5oOfzq4dvrdFACH13wYEHEr",
    soibien: "FjourKXWwl12MoIDd4nj0ZxMwS18G2OUva7wSW6b3iG95Z92x6",
    apaos: "xn1DNyDK4UtDVvPCYBQNcjD5bWOw0XqE6zF69pOt0tWJPFnEpW",
    "policy-sms": "rNPixiLvJ5s198BVppBXvtyNQVStxByvWFJ2PaRB8qknX79Saw"
};
/*
 * map tenant name to bucket slug name
 * if they are not the same
 * */ const cosmicPath = {
    cp: "cpvn",
    vnlife: "vnshop",
    sms: "policy-sms"
};
const cosmicService = {
    getSlugs: async (tenant)=>{
        var ref;
        const resp = await _clients__WEBPACK_IMPORTED_MODULE_0__/* .cosmicApi.get */ .pr.get("/".concat(cosmicPath[tenant] || tenant, "/objects"), {
            params: {
                pretty: true,
                hide_metafields: true,
                props: "slug,title",
                read_key: accessKey[cosmicPath[tenant] || tenant] || "ulISdNDAN9MMpNCfXhTOSNQdh9tF0xXOL65PdIz6cfw7J319cG"
            }
        });
        return resp === null || resp === void 0 ? void 0 : (ref = resp.data) === null || ref === void 0 ? void 0 : ref.objects;
    },
    getPost: async (slug, tenant)=>{
        var ref;
        const resp = await _clients__WEBPACK_IMPORTED_MODULE_0__/* .cosmicApi.get */ .pr.get("/".concat(cosmicPath[tenant] || tenant, "/object/").concat(slug), {
            params: {
                hide_metafields: true,
                type: "posts",
                props: "slug,title,content",
                read_key: accessKey[cosmicPath[tenant] || tenant] || "ulISdNDAN9MMpNCfXhTOSNQdh9tF0xXOL65PdIz6cfw7J319cG"
            }
        });
        return resp === null || resp === void 0 ? void 0 : (ref = resp.data) === null || ref === void 0 ? void 0 : ref.object;
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (cosmicService);


/***/ }),

/***/ 34080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Layout": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20348);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(53769);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-bb101883bc/1/packages/ecommerce/dist/Layout/Footer/Footer.es.js + 1 modules
var Footer_es = __webpack_require__(79217);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-bb101883bc/1/packages/ecommerce/dist/Common/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(18546);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-bb101883bc/1/packages/ecommerce/dist/Common/Messenger/Messenger.es.js + 2 modules
var Messenger_es = __webpack_require__(46899);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(55271);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(79185);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/ScrollTopArrow/ScrollTopArrow.es.js
var ScrollTopArrow_es = __webpack_require__(35336);
// EXTERNAL MODULE: ./tenants/_template/desktop/_module/components/NavigationBar.tsx + 2 modules
var NavigationBar = __webpack_require__(56471);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(55140);
// EXTERNAL MODULE: ./hooks/useTermsAndPolicies.ts
var useTermsAndPolicies = __webpack_require__(29234);
// EXTERNAL MODULE: ./components/ForceLogin.tsx
var ForceLogin = __webpack_require__(41092);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-2db71dd60f/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/router.js
var next_router = __webpack_require__(63438);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/Topbar/Topbar.es.js
var Topbar_es = __webpack_require__(738);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/Zalo/Zalo.es.js + 2 modules
var Zalo_es = __webpack_require__(66409);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/Topbar/TopbarButton.es.js
var TopbarButton_es = __webpack_require__(7934);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-2db71dd60f/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(89053);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./tenants/_template/desktop/_module/_constants.ts
const MEMBERSHIP_POLICY_SLUG_PREFIX = "membership-policy";
const BYPASS_LOGIN_PATHS = /^.*(\/content\/\[id\])|(\/p\/\[slug\])$/g;

;// CONCATENATED MODULE: ./tenants/_template/desktop/_module/Layout.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  height: 56px;\n  @media print {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}












const DndLayout = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4755), __webpack_require__.e(3431), __webpack_require__.e(2399), __webpack_require__.e(7203)]).then(__webpack_require__.bind(__webpack_require__, 17203)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(17203)
            ]
    }
});
const TopBannerHeight = styled_es/* styled.div */.z.div(_templateObject());
const DefaultLayout = (param)=>{
    let { children , banners , leftMenu , rightMenu , footerData , footer , navigationBar , forceLogin =false , layoutAreas  } = param;
    const LoginWrapper = forceLogin ? ForceLogin/* ForceLogin */.D : react.Fragment;
    const { contactLink , isDisplayMessenger , zaloContactLink , partner , footerDataConfig , noOverride , allowRenderCustomPage ,  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const topBanner = banners === null || banners === void 0 ? void 0 : banners[0];
    if (!footer && footerData || noOverride) {
        const footerLayout = noOverride ? _objectSpreadProps(_objectSpread({}, footerData), {
            supportAndPolicy: [
                ...footerDataConfig["supportAndPolicy"]
            ]
        }) : footerData;
        footer = /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_es/* Footer */.$, {
            footer: footerLayout
        });
    }
    const renderContent = ()=>{
        // Render custom pages
        if (allowRenderCustomPage) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DndLayout, {
                header: navigationBar,
                areas: layoutAreas,
                children: children
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !partner && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        topBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBannerHeight, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                                targetPath: topBanner.targetPath,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                                    imageWidth: 1920,
                                    height: 56,
                                    cover: true,
                                    src: topBanner.image
                                })
                            })
                        }),
                        (leftMenu || rightMenu) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Topbar_es/* Topbar */.Z, {
                            leftMenu: leftMenu,
                            rightMenu: rightMenu
                        })
                    ]
                }),
                navigationBar,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: children
                }),
                footer
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginWrapper, {
                children: renderContent()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollTopArrow_es/* ScrollTopArrow */.C, {}),
            contactLink && isDisplayMessenger && /*#__PURE__*/ (0,jsx_runtime.jsx)(Messenger_es/* Messenger */.P, {
                url: contactLink
            }),
            zaloContactLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(Zalo_es/* Zalo */.R, {
                url: zaloContactLink
            })
        ]
    });
};
const Layout = (param)=>{
    let { children , banners , leftMenu , rightMenu , footerData , footer , navigationBar , menuItems , liteLogo , forceLogin =false , layoutAreas  } = param;
    const { identityRequired , hasNews  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { termsAndPolicies  } = (0,useTermsAndPolicies/* useTermsAndPolicies */.N)();
    const { 0: requireLogin , 1: setRequireLogin  } = (0,react.useState)(forceLogin);
    const finalRightActions = hasNews ? [
        /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton_es/* TopbarButton */.S, {
            href: "/tin-tuc",
            children: (0,i18n.t)("Tin tức")
        }, 0),
        ...rightMenu, 
    ] : rightMenu;
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        var ref;
        if (identityRequired && ((ref = router.query) === null || ref === void 0 ? void 0 : ref.ref_code)) {
            sessionStorage.setItem("ref_code", router.query.ref_code.toString());
            setRequireLogin(true);
        } else if (!!sessionStorage.getItem("ref_code")) {
            // for case redirected back after login
            setRequireLogin(true);
        }
    }, []);
    if (!footer && footerData) {
        var ref, ref1;
        if (termsAndPolicies.length > 0 && !!((ref = footerData.supportAndPolicy) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.links)) {
            footerData.supportAndPolicy[0].links = termsAndPolicies.filter((param)=>{
                let { slug  } = param;
                return !slug.includes(MEMBERSHIP_POLICY_SLUG_PREFIX);
            }).map((param)=>{
                let { title , slug  } = param;
                return {
                    children: (0,i18n.t)(title),
                    href: "/".concat(slug),
                    target: "_blank"
                };
            });
        }
        footer = /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_es/* Footer */.$, {
            footer: footerData
        });
    }
    if (!navigationBar) {
        navigationBar = /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationBar/* NavigationBar */.v, {
            menuItems: menuItems,
            showShippingFeeMiniCart: false,
            liteLogo: liteLogo
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayout, {
        leftMenu: leftMenu,
        rightMenu: finalRightActions,
        navigationBar: navigationBar,
        footer: footer,
        footerData: footerData,
        banners: banners,
        forceLogin: requireLogin,
        layoutAreas: layoutAreas,
        children: children
    });
};


/***/ }),

/***/ 56471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ NavigationBar; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20348);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(53769);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-46f73e5ea2/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(17016);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(88384);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(71323);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Container/Container.es.js
var Container_es = __webpack_require__(63512);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(49624);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(58519);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Divider/Divider.es.js
var Divider_es = __webpack_require__(93005);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/PromoOutlined.es.js
var PromoOutlined_es = __webpack_require__(93692);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/OrderOutlined.es.js
var OrderOutlined_es = __webpack_require__(26463);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/ChecklistOutlined.es.js
var ChecklistOutlined_es = __webpack_require__(30221);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/LocationOutlined.es.js
var LocationOutlined_es = __webpack_require__(62204);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(55140);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-2db71dd60f/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/router.js
var next_router = __webpack_require__(63438);
// EXTERNAL MODULE: ./helpers/common.ts
var common = __webpack_require__(89202);
// EXTERNAL MODULE: ./hooks/common.ts
var hooks_common = __webpack_require__(4611);
;// CONCATENATED MODULE: ./hooks/useLiteMode.tsx




const useLiteMode = function(ssrLiteMode) {
    let navOffsetTop = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    const router = (0,next_router.useRouter)();
    const { 0: isLite , 1: setIsLite  } = (0,react.useState)(ssrLiteMode);
    const { 0: dropdownOpen , 1: setDropdownOpen  } = (0,react.useState)(false);
    const listenScrollEvent = ()=>{
        const scrollOffSetTop = window.pageYOffset || document.documentElement.scrollTop;
        if ((0,common/* isHomepage */.GH)(router.asPath)) {
            if (scrollOffSetTop > navOffsetTop) {
                setIsLite(true);
            } else {
                setIsLite(false);
                setDropdownOpen(false);
            }
        } else {
            setIsLite(true);
        }
    };
    (0,react.useEffect)(()=>{
        setDropdownOpen(false);
    }, [
        router.query
    ]);
    (0,react.useEffect)(()=>{
        window.addEventListener("scroll", listenScrollEvent);
        return ()=>{
            window.removeEventListener("scroll", listenScrollEvent);
        };
    }, [
        router.asPath,
        navOffsetTop
    ]);
    (0,hooks_common/* useIsomorphicLayoutEffect */.L)(()=>{
        setIsLite(!(0,common/* isHomepage */.GH)(router.asPath));
    }, [
        router.asPath
    ]);
    const toggle = (0,react.useCallback)(()=>{
        setDropdownOpen(!dropdownOpen);
    }, [
        dropdownOpen
    ]);
    return {
        isLite,
        dropdownOpen,
        toggle
    };
};

// EXTERNAL MODULE: ./hooks/useRegionPicker.tsx
var useRegionPicker = __webpack_require__(54846);
// EXTERNAL MODULE: ./hooks/useLoyalty.ts
var useLoyalty = __webpack_require__(34297);
// EXTERNAL MODULE: ./components/desktop/organisms/UserProfileHeader.tsx
var UserProfileHeader = __webpack_require__(4952);
// EXTERNAL MODULE: ./components/desktop/organisms/NotificationOverview.tsx
var NotificationOverview = __webpack_require__(71770);
// EXTERNAL MODULE: ./components/desktop/organisms/LogoHeader.tsx
var LogoHeader = __webpack_require__(17739);
// EXTERNAL MODULE: ./components/desktop/organisms/SearchBar.tsx + 3 modules
var SearchBar = __webpack_require__(81327);
// EXTERNAL MODULE: ./components/desktop/organisms/PopupRegionPicker.tsx
var PopupRegionPicker = __webpack_require__(34124);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/Topbar/Topbar.es.js
var Topbar_es = __webpack_require__(738);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/MegaMenu/MegaMenu.es.js
var MegaMenu_es = __webpack_require__(19298);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-b1561bfdfb/1/packages/auth-react/dist/context.es.js + 3 modules
var context_es = __webpack_require__(18678);
// EXTERNAL MODULE: ./helpers/navigation-bar.tsx + 1 modules
var navigation_bar = __webpack_require__(88655);
// EXTERNAL MODULE: ./components/desktop/organisms/style.ts
var style = __webpack_require__(67989);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-2db71dd60f/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(89053);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/Dropdown/Dropdown.es.js
var Dropdown_es = __webpack_require__(29556);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/Dropdown/DropdownToggle.es.js
var DropdownToggle_es = __webpack_require__(37753);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/Dropdown/DropdownMenu.es.js
var DropdownMenu_es = __webpack_require__(32762);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-bb101883bc/1/packages/ecommerce/dist/Cart/CartNumberTracking/CartNumberTracking.es.js
var CartNumberTracking_es = __webpack_require__(77405);
// EXTERNAL MODULE: ./modules/cart/CartContextV2.tsx
var CartContextV2 = __webpack_require__(74034);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Badge/Badge.es.js
var Badge_es = __webpack_require__(94053);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/ShoppingCartOutlined.es.js
var ShoppingCartOutlined_es = __webpack_require__(14214);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(28247);
;// CONCATENATED MODULE: ./modules/cart/desktop/CartOverview.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 5px;\n  left: calc(50% + 15px);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











const MiniCart = dynamic_default()(()=>__webpack_require__.e(/* import() */ 6530).then(__webpack_require__.bind(__webpack_require__, 76530)).then((mod)=>mod.MiniCart), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(76530)
            ]
    }
});
const StyledDropdown = (0,emotion_styled_browser_esm/* default */.Z)(Dropdown_es/* Dropdown */.L)(_templateObject());
const WrapperBadge = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1());
const CartOverview = (param)=>{
    let { vertical =false , showShippingFeeMiniCart =true  } = param;
    const { flattenItems , totalCartItems  } = (0,CartContextV2/* useCartV2 */.T)();
    const { 0: miniCartOpen , 1: setMiniCartOpen  } = (0,react.useState)(false);
    const toggleMiniCart = (0,react.useCallback)(()=>{
        setMiniCartOpen(!miniCartOpen);
    }, [
        miniCartOpen
    ]);
    (0,react.useEffect)(()=>{
        if (true) {
            if (miniCartOpen) {
                document.body.style.overflow = "hidden";
                document.body.style.paddingRight = "".concat(getScrollbarWidth(), "px");
            } else {
                document.body.style.overflow = "unset";
                document.body.style.paddingRight = "unset";
            }
        }
    }, [
        miniCartOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDropdown, _objectSpreadProps(_objectSpread({
        isOpen: miniCartOpen,
        toggle: toggleMiniCart,
        toggleType: "hover",
        onHide: ()=>setMiniCartOpen(false)
    }, (0,helper_es/* getTrackingData */.O)({
        isTrackContent: true,
        regionName: "headerBar",
        contentName: "cartItem",
        target: "shoppingCart"
    })), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownToggle_es/* DropdownToggle */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                        href: "/cart",
                        children: vertical ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, {
                            className: "button",
                            style: {
                                flexDirection: "column"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShoppingCartOutlined_es/* ShoppingCartOutlined */.O, {
                                    size: 36,
                                    color: "textSecondary"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                    level: 2,
                                    weight: "medium",
                                    color: "textSecondary",
                                    className: "title",
                                    children: (0,i18n.t)("Giỏ h\xe0ng")
                                }),
                                totalCartItems > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperBadge, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge_es/* Badge */.C, {
                                        count: totalCartItems
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShoppingCartOutlined_es/* ShoppingCartOutlined */.O, {
                                    size: 36,
                                    color: "textSecondary"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-left ml-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                            level: 2,
                                            weight: "medium",
                                            color: "textSecondary",
                                            className: "title",
                                            children: (0,i18n.t)("Giỏ h\xe0ng của bạn")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                            level: 2,
                                            weight: "medium",
                                            color: "textSecondary",
                                            className: "title",
                                            children: (0,i18n.t)("({{cartTotalCartItems}}) sản phẩm", {
                                                cartTotalCartItems: flattenItems.length
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartNumberTracking_es/* CartNumberTracking */.w, {
                        totalItems: totalCartItems
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenu_es/* DropdownMenu */.h, {
                popperConfig: {
                    placement: "top-end"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniCart, {
                    onHide: ()=>setMiniCartOpen(false),
                    showShippingFee: showShippingFeeMiniCart
                })
            })
        ]
    }));
};
const getScrollbarWidth = ()=>{
    let width = 0;
    if ( true && document.body.scrollHeight > window.innerHeight) {
        if (window.scrollbarWidth) {
            return window.scrollbarWidth;
        }
        const outer = document.createElement("div");
        outer.style.visibility = "hidden";
        outer.style.overflow = "scroll";
        document.body.appendChild(outer);
        const inner = document.createElement("div");
        outer.appendChild(inner);
        width = outer.offsetWidth - inner.offsetWidth;
        outer.parentNode.removeChild(outer);
        window.scrollbarWidth = width;
    }
    return width;
};

;// CONCATENATED MODULE: ./tenants/_template/desktop/_module/components/NavigationBar.tsx
function NavigationBar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function NavigationBar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            NavigationBar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function NavigationBar_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function NavigationBar_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        NavigationBar_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function NavigationBar_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function NavigationBar_templateObject() {
    const data = NavigationBar_taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 550;\n  background: rgba(0, 0, 0, 0.5);\n  -webkit-transition-delay: 0.1s;\n  transition-delay: 0.1s;\n"
    ]);
    NavigationBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















const StyledNavigationBar = emotion_styled_browser_esm/* default.div */.Z.div((param)=>{
    let { lite , verticalNavItem  } = param;
    return "\n  @media print {\n    display: none;\n  }\n  background-color: #fff;\n  position: sticky;\n  top: 0;\n  z-index: 1040;\n  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);\n  @media screen and (max-width: 767px) {\n    height: auto !important;\n  }\n\n  ".concat(lite && verticalNavItem ? "\n      min-width: 68px;\n      .title {\n        visibility: hidden;\n        height: 0;\n      }\n      .button {\n        gap: 0;\n      }\n    " : "", "\n");
});
const NavItem = emotion_styled_browser_esm/* default.div */.Z.div((param)=>{
    let { theme  } = param;
    return "\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.5rem;\n  cursor: pointer;\n  &:hover {\n    div {\n      color: ".concat(theme.colors.primary500, " !important;\n    }\n    path {\n      fill: ").concat(theme.colors.primary500, " !important;\n    }\n  }\n");
});
const Overlay = emotion_styled_browser_esm/* default.div */.Z.div(NavigationBar_templateObject());
const isVerticalNavItem = (tenant)=>{
    switch(tenant){
        // case 'phongvu':
        //   return true;
        case "ipp":
            return true;
        default:
            return false;
    }
};
const defaultDisplayConfig = {
    order: false,
    promotion: false,
    login: true,
    cart: true,
    additional: undefined
};
const NavigationBar = (param)=>{
    let { showShippingFeeMiniCart =true , menuItems , liteLogo , displayConfig  } = param;
    displayConfig = NavigationBar_objectSpread({}, defaultDisplayConfig, displayConfig);
    const { 0: navOffsetTop , 1: setNavOffsetTop  } = (0,react.useState)(0);
    const { 0: navItems , 1: setNavItems  } = (0,react.useState)([]);
    const { isLite , dropdownOpen , toggle  } = useLiteMode(liteLogo, navOffsetTop);
    const { partner , tenant , megaMenuType ="vertical" , alignMegaMenu ="left" , notificationAppId ,  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const regionPickerProps = (0,useRegionPicker/* useRegionPicker */.j)();
    const { user , authService  } = (0,context_es/* useAuth */.a)();
    const onLogin = ()=>authService.login();
    const router = (0,next_router.useRouter)();
    const region = regionPickerProps === null || regionPickerProps === void 0 ? void 0 : regionPickerProps.activeLocation;
    const { loyaltyMemberInfo  } = (0,useLoyalty/* useLoyalty */.m)();
    const profileLinks = (0,react.useMemo)(()=>{
        return (0,navigation_bar/* getNavItems */.r)({
            tenant,
            logged: !!(user === null || user === void 0 ? void 0 : user.userId),
            isLoyaltyMember: !!loyaltyMemberInfo,
            showNotificationItem: !!notificationAppId
        });
    }, [
        tenant,
        user
    ]);
    const promotionIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
        href: "/khuyen-mai",
        target: "_blank",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, NavigationBar_objectSpreadProps(NavigationBar_objectSpread({
            className: "button",
            style: isVerticalNavItem(tenant) ? {
                flexDirection: "column"
            } : {
                flexDirection: "row"
            }
        }, (0,helper_es/* getTrackingData */.O)({
            isTrackContent: true,
            regionName: "headerBar",
            contentName: "promotionLandingIcon"
        })), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoOutlined_es/* PromoOutlined */.G, {
                    size: 36,
                    color: "textSecondary"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "title",
                    children: (0,i18n.t)("Khuyến m\xe3i")
                })
            ]
        }))
    });
    const orderIcon = /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, NavigationBar_objectSpreadProps(NavigationBar_objectSpread({
        className: "button",
        onClick: ()=>{
            if (!(user === null || user === void 0 ? void 0 : user.userId)) {
                onLogin();
            } else {
                router.push("/account/orders");
            }
        },
        style: isVerticalNavItem(tenant) ? {
            flexDirection: "column"
        } : {
            flexDirection: "row"
        }
    }, (0,helper_es/* getTrackingData */.O)({
        isTrackContent: true,
        regionName: "headerBar",
        contentName: "orderIcon"
    })), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderOutlined_es/* OrderOutlined */.y, {
                size: 36,
                color: "textSecondary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "title",
                children: (0,i18n.t)("Đơn h\xe0ng")
            })
        ]
    }));
    const loginIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfileHeader/* UserProfileHeader */.F, {
        vertical: isVerticalNavItem(tenant),
        customProfile: !!partner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
            href: "/account/orders",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, {
                className: "button",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChecklistOutlined_es/* ChecklistOutlined */.H, {
                        size: 36,
                        color: "textSecondary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: (0,i18n.t)("Quản l\xfd đơn h\xe0ng")
                    })
                ]
            })
        }) : undefined,
        profileLinks: profileLinks
    });
    const notificationIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationOverview/* NotificationOverview */.C, {
        title: isVerticalNavItem(tenant)
    });
    const cartIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(CartOverview, {
        showShippingFeeMiniCart: showShippingFeeMiniCart,
        vertical: isVerticalNavItem(tenant)
    });
    const regionPickerIcon = /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavItem, NavigationBar_objectSpreadProps(NavigationBar_objectSpread({
        onClick: ()=>{
            regionPickerProps.onOpenPopup();
        }
    }, (0,helper_es/* getTrackingData */.O)({
        isTrackContent: true,
        regionName: "headerBar",
        contentName: "location"
    })), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOutlined_es/* LocationOutlined */.f, {
                size: 36,
                color: "textSecondary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Body */.uT, {
                level: 2,
                weight: "medium",
                color: "textSecondary",
                children: [
                    (0,i18n.t)("Khu vực nhận h\xe0ng"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    region && region.label
                ]
            })
        ]
    }));
    (0,react.useEffect)(()=>{
        const getNavMenuByDisplayConfig = ()=>{
            var ref;
            const { order , promotion , login , cart , additional  } = displayConfig;
            const navMenu = [];
            if (promotion) navMenu.push(promotionIcon);
            if (order) navMenu.push(orderIcon);
            if (login) navMenu.push(loginIcon);
            if (notificationAppId) navMenu.push(notificationIcon);
            if (cart) navMenu.push(cartIcon);
            if (region && (regionPickerProps === null || regionPickerProps === void 0 ? void 0 : (ref = regionPickerProps.terminals) === null || ref === void 0 ? void 0 : ref.length) > 1) navMenu.push(regionPickerIcon);
            if (additional) navMenu.push(additional);
            return navMenu;
        };
        setNavItems(getNavMenuByDisplayConfig());
    }, [
        user === null || user === void 0 ? void 0 : user.userId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            dropdownOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNavigationBar, {
                lite: isLite,
                verticalNavItem: isVerticalNavItem(tenant),
                id: "mainNavigationBar",
                ref: (navRef)=>{
                    if (navRef) {
                        const { scrollTop  } = document.documentElement;
                        setNavOffsetTop(scrollTop % Topbar_es/* TOPBAR_HEIGHT */.n);
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container_es/* Container */.W, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                            gutter: [
                                16,
                                16
                            ],
                            align: "middle",
                            style: megaMenuType === "vertical" && isVerticalNavItem(tenant) && isLite ? {
                                height: "72px"
                            } : {
                                height: "88px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoHeader/* LogoHeader */.S, {
                                        isLite: megaMenuType === "vertical" && ( true ? isLite : 0),
                                        dropdownOpen: dropdownOpen,
                                        toggle: toggle,
                                        // Only show mega menu dropdown on type vertical
                                        menuItems: megaMenuType === "vertical" ? menuItems : []
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                    flex: "auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBar/* SearchBar */.E, {})
                                }),
                                navItems.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                        children: item
                                    }, index))
                            ]
                        })
                    }),
                    megaMenuType === "horizontal" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_es/* Divider */.i, {
                                gap: 0,
                                color: "divider"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container_es/* Container */.W, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                        span: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_es/* MegaMenu */.V, {
                                            type: "horizontal",
                                            align: alignMegaMenu,
                                            menuItems: menuItems
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupRegionPicker/* PopupRegionPicker */.H, NavigationBar_objectSpread({}, regionPickerProps))
        ]
    });
};


/***/ }),

/***/ 85172:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = void 0;
/**
 * Copyright (c) Grab Taxi Holdings PTE LTD (GRAB)
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// TODO: Maybe, we do not need to export them.
var simplify_callback_1 = __webpack_require__(5828);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return simplify_callback_1.StreamEvent; } });
var subscription_1 = __webpack_require__(96773);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return subscription_1.createDataStream; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return subscription_1.createSubscription; } });
var wrap_global_1 = __webpack_require__(13371);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return wrap_global_1.getModuleEnvironment; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return wrap_global_1.wrapModule; } });
const utils_1 = __webpack_require__(41405);
const wrap_global_2 = __webpack_require__(13371);
function setWrapModuleToGlobal() {
    // @ts-ignore
    __webpack_require__.g['wrapModule'] = wrap_global_2.wrapModule;
    // @ts-ignore
    __webpack_require__.g['isTerraAvailable'] = utils_1.checkIsTerraAvailable;
}
setWrapModuleToGlobal();


/***/ }),

/***/ 5828:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Grab Taxi Holdings PTE LTD (GRAB)
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.simplifyCallback = exports.StreamEvent = void 0;
const subscription_1 = __webpack_require__(96773);
const utils_1 = __webpack_require__(41405);
/**
 * Represents stream events that be used to communicate state of the stream
 * from native to web.
 */
var StreamEvent;
(function (StreamEvent) {
    StreamEvent["STREAM_TERMINATED"] = "STREAM_TERMINATED";
})(StreamEvent = exports.StreamEvent || (exports.StreamEvent = {}));
/**
 * Convert the callback to a stream to receive continual values.
 * @template T The emission value type.
 * @param global The global object - generally window.
 * @param param1 Parameters for stream creation.
 * @return A stream that can be subscribed to.
 */
function streamCallback(global, { callbackNameFunc, funcToWrap }) {
    return subscription_1.createDataStream((handlers) => {
        /** Generate callback name dynamically to make this stream idempotent. */
        const callbackName = callbackNameFunc();
        let subscription;
        global[callbackName] = (data) => {
            if (utils_1.isType(data.result, 'event')) {
                switch (data.result.event) {
                    case StreamEvent.STREAM_TERMINATED:
                        subscription.unsubscribe();
                        break;
                }
            }
            else {
                const { result, error, status_code } = data;
                !!handlers &&
                    !!handlers.next &&
                    handlers.next({
                        result: result === null ? undefined : utils_1.parseJson(result),
                        error: error === null ? undefined : error,
                        status_code: status_code === null ? undefined : status_code,
                    });
            }
        };
        /**
         * Beware that this function may throw a non-recoverable error, such
         * as module not available. In that case, we should let this call fail
         * and ensure the error is caught downstream.
         */
        funcToWrap(callbackName);
        subscription = subscription_1.createSubscription(() => {
            /**
             * Native should check for the existence of this callback every time a
             * value is bound to be delivered. If no such callback exists, it may
             * be assumed that the web client has unsubscribed from this stream, and
             * therefore the stream may be terminated on the mobile side.
             */
            global[callbackName] = undefined;
            !!handlers && !!handlers.complete && handlers.complete();
        });
        return subscription;
    });
}
/**
 * Handle the simplication of callbacks for both single asynchronous return
 * values and streams.
 * @param global The global object - generally window.
 * @param param1 Parameters for callback simplification.
 * @return Check the return types for private functions in this module.
 */
function simplifyCallback(global, _a) {
    var { funcNameToWrap } = _a, restParams = __rest(_a, ["funcNameToWrap"]);
    return streamCallback(global, restParams);
}
exports.simplifyCallback = simplifyCallback;


/***/ }),

/***/ 96773:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/**
 * Copyright (c) Grab Taxi Holdings PTE LTD (GRAB)
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createDataStream = exports.createSubscription = void 0;
/**
 * Create a subscription that can only be unsubscribed from once.
 * @param unsubscribe Unsubscription logic.
 */
function createSubscription(unsubscribe) {
    let unsubscribed = false;
    return {
        isUnsubscribed: () => unsubscribed,
        unsubscribe: () => {
            if (!unsubscribed) {
                unsubscribe();
                unsubscribed = true;
            }
        },
    };
}
exports.createSubscription = createSubscription;
/**
 * Create a data stream with default functionalities. When we implement
 * Promise functionalities, beware that if then block is executed immediately
 * (i.e. a resolved promise), the subscription object may not be created yet.
 *
 * The call to subscribe may throw an error which we need to catch, due to the
 * asynchronous nature of Promises. This error will then be passed to the
 * reject call.
 * @param subscribe Injected subscribe function.
 * @return A DataStream instance.
 */
function createDataStream(subscribe) {
    return {
        subscribe,
        then: (onFulfilled, onRejected) => {
            return new Promise((resolve, reject) => {
                try {
                    let subscription = null;
                    let didFinish = false;
                    subscription = subscribe({
                        next: data => {
                            if (onFulfilled == null) {
                                // @ts-ignore
                                resolve(undefined);
                            }
                            else {
                                resolve(onFulfilled(data));
                            }
                            !!subscription && subscription.unsubscribe();
                            didFinish = true;
                        },
                    });
                    if (didFinish)
                        !!subscription && subscription.unsubscribe();
                }
                catch (e) {
                    if (onRejected == null) {
                        reject(e);
                    }
                    else {
                        resolve(onRejected(e));
                    }
                }
            });
        },
    };
}
exports.createDataStream = createDataStream;


/***/ }),

/***/ 41405:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Grab Taxi Holdings PTE LTD (GRAB)
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.checkIsTerraAvailableIOS = exports.checkIsTerraAvailableAndroid = exports.checkIsTerraAvailable = exports.parseJson = exports.wrapModuleName = exports.isType = exports.getFirstAvailableCallbackName = exports.getCallbackName = exports.getObjectKeys = void 0;
/**
 * Get the keys of an object.
 * @param object Some object.
 * @return Array of object keys.
 */
function getObjectKeys(object) {
    return [...Object.keys(object), ...Object.getOwnPropertyNames(Object.getPrototypeOf(object))];
}
exports.getObjectKeys = getObjectKeys;
/**
 * Get the callback name that will be used to access global callback.
 * @param param0 The required parameters.
 * @return The combined callback name.
 */
function getCallbackName({ moduleName, funcName, requestID: req, }) {
    return `${moduleName}_${funcName}Callback${req !== null ? `_${req}` : ''}`;
}
exports.getCallbackName = getCallbackName;
/**
 * Instead of keeping state, find the first available callback name by
 * iterating through all callback names in the global object and pick the next
 * one.
 */
function getFirstAvailableCallbackName(global, { moduleName, funcName }) {
    let nextAvailableRequestID = 0;
    return (() => {
        let callbackName = '';
        while ((callbackName = getCallbackName({
            moduleName,
            funcName,
            requestID: nextAvailableRequestID,
        })) in global) {
            nextAvailableRequestID += 1;
        }
        nextAvailableRequestID += 1;
        return callbackName;
    })();
}
exports.getFirstAvailableCallbackName = getFirstAvailableCallbackName;
/**
 * Check if an object is of a certain type.
 * @param object Some object.
 * @return Whether the object is of this type.
 */
function isType(object, ...keys) {
    if (!object)
        return false;
    const objectKeys = getObjectKeys(object);
    return keys.every((key) => objectKeys.indexOf(key) >= 0);
}
exports.isType = isType;
/**
 * Wrap a module name to mark it as wrapped.
 * @param moduleName The original module name.
 * @return The wrapped module name.
 */
function wrapModuleName(moduleName) {
    return `Wrapped${moduleName}`;
}
exports.wrapModuleName = wrapModuleName;
function parseJson(json) {
    if (typeof json != 'string') {
        return json;
    }
    try {
        return JSON.parse(json);
    }
    catch (error) {
        return json;
    }
}
exports.parseJson = parseJson;
function checkIsTerraAvailable() {
    return checkIsTerraAvailableAndroid() || checkIsTerraAvailableIOS();
}
exports.checkIsTerraAvailable = checkIsTerraAvailable;
function checkIsTerraAvailableAndroid() {
    // @ts-ignore
    return !!__webpack_require__.g['TerraWebModule'];
}
exports.checkIsTerraAvailableAndroid = checkIsTerraAvailableAndroid;
function checkIsTerraAvailableIOS() {
    // @ts-ignore
    return !!__webpack_require__.g.webkit && !!__webpack_require__.g.webkit.messageHandlers && !!__webpack_require__.g.webkit.messageHandlers['TerraWebModule'];
}
exports.checkIsTerraAvailableIOS = checkIsTerraAvailableIOS;


/***/ }),

/***/ 4868:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Grab Taxi Holdings PTE LTD (GRAB)
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.wrapGenericModule = void 0;
const simplify_callback_1 = __webpack_require__(5828);
const utils_1 = __webpack_require__(41405);
/**
 * Wrap a generic module. This should work for both Android and iOS-injected
 * Javascript interfaces.
 * @param global The global object - generally window.
 * @param moduleName The name of the module that owns the method.
 * @param moduleMethodFunc Function to execute the related module method.
 * @return The wrapped module.
 */
function wrapGenericModule(global, moduleName, moduleMethodFunc) {
    return {
        invoke: (method, params) => {
            return simplify_callback_1.simplifyCallback(global, {
                funcNameToWrap: method,
                callbackNameFunc: () => utils_1.getFirstAvailableCallbackName(global, {
                    moduleName,
                    funcName: method,
                }),
                funcToWrap: callback => moduleMethodFunc({
                    subscriberId: callback,
                    method,
                    module: moduleName,
                    parameters: params !== undefined && params !== null ? params : {},
                }),
            });
        },
    };
}
exports.wrapGenericModule = wrapGenericModule;


/***/ }),

/***/ 13371:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Grab Taxi Holdings PTE LTD (GRAB)
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.wrapModule = exports.getModuleEnvironment = void 0;
const utils_1 = __webpack_require__(41405);
const wrap_generic_1 = __webpack_require__(4868);
/**
 * Get the module's mobile environment.
 * @param global The global object - generally window.
 * @param moduleName The name of the module being wrapped.
 */
function getModuleEnvironment(global, moduleName) {
    if (!!global[moduleName]) {
        return 'android';
    }
    else if (!!global.webkit && !!global.webkit.messageHandlers && !!global.webkit.messageHandlers[moduleName]) {
        return 'ios';
    }
    return undefined;
}
exports.getModuleEnvironment = getModuleEnvironment;
/**
 * Wrap the appropriate module based on whether or not it's Android/iOS.
 * @param global The global object - generally window.
 * @param moduleName The name of the module being wrapped.
 */
function wrapModule(global, moduleName) {
    global[utils_1.wrapModuleName(moduleName)] = wrap_generic_1.wrapGenericModule(global, moduleName, (params) => {
        if (!!global['TerraWebModule']) {
            //this case for android
            global['TerraWebModule'].invoke(moduleName, params.method, params.subscriberId, JSON.stringify(params));
        }
        else if (!!global.webkit &&
            !!global.webkit.messageHandlers &&
            !!global.webkit.messageHandlers['TerraWebModule']) {
            //this case for ios
            global.webkit.messageHandlers['TerraWebModule'].postMessage({
                moduleName: moduleName,
                methodName: params.method,
                subscriberId: params.subscriberId,
                requestString: JSON.stringify(params),
            });
        }
        else {
            throw new Error(`Unexpected method '${params.method}' for module '${moduleName}'`);
        }
    });
}
exports.wrapModule = wrapModule;


/***/ }),

/***/ 67085:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 46586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CL": function() { return /* binding */ trackRemoveFromCart; },
/* harmony export */   "Kc": function() { return /* binding */ trackAddToCart; },
/* harmony export */   "_g": function() { return /* binding */ trackChangeQuantityProduct; },
/* harmony export */   "bz": function() { return /* binding */ trackSelectProduct; },
/* harmony export */   "gu": function() { return /* binding */ trackManually; },
/* harmony export */   "ih": function() { return /* binding */ trackDecreaseQuantityProduct; },
/* harmony export */   "lM": function() { return /* binding */ trackIncreaseQuantityProduct; },
/* harmony export */   "wr": function() { return /* binding */ trackAddToCartManually; }
/* harmony export */ });
/* harmony import */ var _interface_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41873);


const trackAddToCart = (product, selectedPromotionId, type, status, cartId) => {
  var _a;
  const { defaultPromotions = [] } = product;
  window.track(type ? type : _interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART, {
    cartId,
    skuId: product.productInfo.sku,
    skuName: product.productInfo.name,
    promotionId: `${[
      ...defaultPromotions.map((promo) => promo.id),
      selectedPromotionId || ""
    ].join(",")}`,
    status: status || "success",
    quantity: 1,
    price: parseInt(product.prices[0].supplierRetailPrice),
    promotionPrice: product.addToCartPrice
  });
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: _interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART,
    ecommerce: {
      currencyCode: "VND",
      add: {
        products: [
          {
            name: product.productInfo.name,
            id: product.productInfo.sku,
            price: product.addToCartPrice,
            quantity: 1,
            category: ""
          }
        ]
      }
    }
  });
};
const trackIncreaseQuantityProduct = (item, diff = 1, cartId) => {
  var _a;
  window.track("increaseQuantityProduct", {
    cartId,
    skuId: item.sku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity + diff,
    price: item.sellPrice,
    promotionPrice: item.price
  });
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: _interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART,
    ecommerce: {
      currencyCode: "VND",
      add: {
        products: [
          {
            name: item.name,
            id: item.sku,
            price: item.price,
            quantity: diff,
            category: ""
          }
        ]
      }
    }
  });
};
const trackDecreaseQuantityProduct = (item, diff = 1, cartId) => {
  window.track("decreaseQuantityProduct", {
    cartId,
    skuId: item.sku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity - diff,
    price: item.sellPrice,
    promotionPrice: item.price
  });
};
const trackChangeQuantityProduct = (item, newQty, cartId) => {
  const currQty = item.quantity;
  if (currQty < newQty) {
    trackIncreaseQuantityProduct(item, newQty - currQty, cartId);
  } else if (currQty > newQty) {
    trackDecreaseQuantityProduct(item, currQty - newQty, cartId);
  }
};
const trackRemoveFromCart = (item, cartId) => {
  var _a;
  window.track("removeFromCart", {
    cartId,
    skuId: item.sku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity,
    price: item.price,
    promotionPrice: item.sellPrice
  });
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: "removeFromCart",
    ecommerce: {
      remove: {
        products: [
          {
            name: item.name,
            id: item.sku,
            price: item.price,
            quantity: item.quantity,
            category: ""
          }
        ]
      }
    }
  });
};
const trackManually = (contentName, regionName, target, payload) => {
  window.track("manualTrackInteractionContent", {
    interaction: "click",
    contentName,
    regionName,
    target,
    payload
  });
};
const trackAddToCartManually = (trackingScreenName, sku) => {
  return trackManually("addToCart", "productCard", trackingScreenName, JSON.stringify({
    sku,
    screenName: trackingScreenName,
    index: 0
  }));
};
const trackSelectProduct = (item, checked, cartId) => {
  window.track(checked ? "selectProduct" : "unselectProduct", {
    cartId,
    skuId: item.sku,
    skuName: item.name,
    price: item.sellPrice,
    promotionPrice: item.price,
    quantity: item.quantity,
    status: "success"
  });
};




/***/ }),

/***/ 41873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ AddToCartType; }
/* harmony export */ });
var AddToCartType = /* @__PURE__ */ ((AddToCartType2) => {
  AddToCartType2["ADDTOCART"] = "addToCart";
  AddToCartType2["BUYNOW"] = "buyNow";
  return AddToCartType2;
})(AddToCartType || {});




/***/ }),

/***/ 84019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v2": function() { return /* reexport */ Alignment; },
  "hT": function() { return /* reexport */ DSSize; },
  "fd": function() { return /* reexport */ DividerStyleEnum; }
});

// UNUSED EXPORTS: DividerTypeEnum, Variant, VerticalAlignment

;// CONCATENATED MODULE: ../../packages/types/dist/shared/enum.es.js
var Variant = /* @__PURE__ */ ((Variant2) => {
  Variant2["primary"] = "primary";
  Variant2["secondary"] = "secondary";
  Variant2["ghost"] = "ghost";
  Variant2["link"] = "link";
  return Variant2;
})(Variant || {});
var Alignment = /* @__PURE__ */ ((Alignment2) => {
  Alignment2["left"] = "left";
  Alignment2["center"] = "center";
  Alignment2["right"] = "right";
  Alignment2["justify"] = "justify";
  return Alignment2;
})(Alignment || {});
var VerticalAlignment = /* @__PURE__ */ ((VerticalAlignment2) => {
  VerticalAlignment2["top"] = "top";
  VerticalAlignment2["center"] = "center";
  VerticalAlignment2["bottom"] = "bottom";
  return VerticalAlignment2;
})(VerticalAlignment || {});
var DSSize = /* @__PURE__ */ ((DSSize2) => {
  DSSize2["small"] = "small";
  DSSize2["default"] = "default";
  DSSize2["large"] = "large";
  return DSSize2;
})(DSSize || {});
var DividerTypeEnum = /* @__PURE__ */ ((DividerTypeEnum2) => {
  DividerTypeEnum2["text"] = "text";
  DividerTypeEnum2["icon"] = "icon";
  return DividerTypeEnum2;
})(DividerTypeEnum || {});
var DividerStyleEnum = /* @__PURE__ */ ((DividerStyleEnum2) => {
  DividerStyleEnum2["solid"] = "solid";
  DividerStyleEnum2["double"] = "double";
  DividerStyleEnum2["dotted"] = "dotted";
  DividerStyleEnum2["dashed"] = "dashed";
  return DividerStyleEnum2;
})(DividerStyleEnum || {});



;// CONCATENATED MODULE: ../../packages/types/dist/shared/index.es.js



/***/ })

}]);